/*
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2022-07-26 14:27:33
 * @LastEditors: DESKTOP-FKE5GMS\17601 1760178806@qq.com
 * @LastEditTime: 2023-11-28 16:32:07
 * @FilePath: \合联\oms\src\api\storage\return.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from "@/libs/api.request";

export const getReturn = (data) => {
  return axios.request({
    url: `/warehouse/getPackageList`,
    method: "post",
    data,
  });
};

export const submitPlan = (data) => {
  return axios.request({
    url: `/warehouse/returnSell`,
    method: "post",
    data,
  });
};

// 虚拟仓操作
export const getVirtualReturn = (data) => {
  return axios.request({
    url: `/warehouse/setPackageOnSelf`,
    method: "post",
    data,
  });
};

// 修改装袋方案
export const updatePlan = (data) => {
  return axios.request({
    url: `/warehouse/updatePackageStatus`,
    method: "post",
    data,
  });
};

// 退件方案
export const getReturnPlan = (data) => {
  return axios.request({
    url: `/warehouse/omsPackageBatchPlan`,
    method: "put",
    data,
  });
};

export const instruct = (data) => {
  return axios.request({
    url: "/warehouse/tiktok/package/instruct",
    method: "post",
    data,
  });
};


export const deleteAbnormalPackage = (data) => {
  return axios.request({
    url: "/warehouse/deleteAbnormalPackage",
    method: "post",
    data,
  });
};
